const BLOG_BRAND_SUFFIX = /\s*\|\s*Phil Carr(?:\s+SEO Consultant(?:\s*&\s*Web Strategist)?)?\s*$/i;

export const SITE_URL = "https://www.phil-carr.co.uk";
export const PERSON_ID = `${SITE_URL}/#person`;
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;

// Search titles are separate from visible page headings.
const SEARCH_TITLE_OVERRIDES: Record<string, string> = {
  "/seo/huddersfield": "SEO Huddersfield: Consultant & Strategy | Phil Carr",
  "/seo/sheffield": "Sheffield SEO Consultant | Phil Carr",
  "/seo/wakefield": "Wakefield SEO Consultant | Phil Carr",
  "/seo/trades/builders": "SEO for Builders: Local Quote Enquiries | Phil Carr",
  "/seo/trades/plumbers": "SEO for Plumbers: Local Plumbing Leads | Phil Carr",
  "/sitemap": "Website Sitemap: Pages and Services | Phil Carr",
  "/seo/leeds/pricing": "Leeds SEO Pricing: Costs and Options | Phil Carr",
  "/blog/local-seo-in-2022": "Local SEO in 2022: Key Changes | Phil Carr",
  "/projects": "Website Projects: Design and SEO Work | Phil Carr",
  "/blog/website-redesign-seo-migration-checklist": "Website Redesign SEO Migration Checklist | Phil Carr",
  "/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns": "2024 Algorithm Updates: Core & Spam | Phil Carr",
  "/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook": "AI-Driven Search 90-Day Plan | Phil Carr",
  "/blog/barnsley-seo-for-accountants-how-to-attract-higher-value-leads": "Barnsley SEO for Accountants | Phil Carr",
  "/blog/barnsley-seo-for-dental-and-health-clinics-local-patient-growth": "Barnsley SEO for Dental Clinics | Phil Carr",
  "/blog/barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries": "Barnsley SEO for Solicitors | Phil Carr",
  "/blog/how-much-does-seo-cost-for-a-wakefield-business-in-2026": "Wakefield SEO Costs in 2026 | Phil Carr",
  "/blog/how-to-hire-an-seo-consultant": "How to Hire an SEO Consultant | Phil Carr",
  "/blog/how-to-optimise-your-google-business-profile": "Google Business Profile SEO Guide | Phil Carr",
  "/blog/oracle-training-consultants-new-website": "Oracle Training Website Rebuild | Phil Carr",
  "/blog/sentinel-door-systems-new-website": "Sentinel Door Systems Website Rebuild | Phil Carr",
  "/projects/sentinel-door-systems": "Sentinel Door Systems Web Design & SEO | Phil Carr",
  "/projects/oracle-training-consultants": "Oracle Training Web Design & WooCommerce | Phil Carr",
  "/software-development": "Software Development: Web Apps & SaaS | Phil Carr",
  "/bespoke-app-development": "Bespoke Mobile & Web App Development | Phil Carr",
  "/shopify-websites": "Shopify Website Design & Ecommerce Stores | Phil Carr",
  "/website-management": "Website Management, Maintenance & Support | Phil Carr",
  "/terms-and-conditions": "Terms & Conditions for SEO and Web Services | Phil Carr",
  "/areas": "SEO & Web Design Across Yorkshire | Phil Carr",
  "/seo/doncaster": "SEO Doncaster: Local Business Strategy | Phil Carr",
  "/seo/rotherham": "SEO Rotherham: Local Business Strategy | Phil Carr",
  "/blog/how-builders-can-get-more-quote-requests-from-google": "More Google Quote Requests for Builders | Phil Carr",
  "/blog/july-2026-ai-search-what-small-businesses-should-do-now": "AI Search for Small Businesses: July 2026 | Phil Carr",
  "/blog/how-law-firms-can-improve-search-led-enquiry-quality": "Better SEO Enquiries for Law Firms | Phil Carr",
  "/blog/july-2026-google-core-update-recovery-playbook": "Google Core & Spam Recovery: July 2026 | Phil Carr",
  "/blog/local-search-in-2025-personalisation-and-contextual-relevance": "Local Search in 2025: Personalisation | Phil Carr",
  "/blog/private-dental-seo-treatment-pages-that-convert-patients": "Private Dental SEO: Better Treatment Pages | Phil Carr",
  "/blog/local-seo-for-accountancy-firms-what-matters-most": "Local SEO for Accountancy Firms | Phil Carr",
  "/blog/how-accountancy-websites-can-improve-enquiry-quality": "Accountancy Websites: Better Enquiries | Phil Carr",
  "/blog/salon-treatment-pages-that-improve-seo-performance": "Salon Treatment Pages for Better SEO | Phil Carr",
  "/blog/ai-in-search-the-rise-of-generative-experiences": "AI Search and Generative Experiences | Phil Carr",
  "/blog/a-year-of-change-googles-2021-algorithm-updates": "Google's 2021 Algorithm Updates Explained | Phil Carr",
  "/blog/understanding-googles-latest-algorithm-update": "Google Algorithm Updates: Barnsley SEO | Phil Carr",
  "/blog/how-hairdressers-can-get-more-bookings-from-google": "More Google Bookings for Hairdressers | Phil Carr",
  "/blog/building-a-website-that-supports-seo-and-business-growth": "Building a Website for SEO and Growth | Phil Carr",
  "/blog/creating-an-seo-plan-that-supports-long-term-success": "Creating a Long-Term SEO Plan | Phil Carr",
  "/blog/common-seo-mistakes-that-hold-small-businesses-back": "Common Small Business SEO Mistakes | Phil Carr",
  "/blog/connecting-seo-to-revenue-in-an-ai-influenced-world-revision": "Connecting SEO to Revenue in AI Search | Phil Carr",
  "/blog/data-driven-decisions-leveraging-ga4-for-seo-success": "Using GA4 Data to Improve SEO Decisions | Phil Carr",
  "/blog/generative-ai-and-content-creation-balancing-automation-and-authenticity": "Generative AI Content: Keeping It Authentic | Phil Carr",
  "/blog/how-long-does-seo-take-in-sheffield-a-practical-timeline": "How Long Does SEO Take in Sheffield? | Phil Carr",
  "/blog/how-much-does-seo-cost-for-a-barnsley-business-in-2026": "How Much Does SEO Cost in Barnsley in 2026? | Phil Carr",
  "/blog/how-seo-builds-momentum-over-time-for-small-businesses": "How Small Business SEO Builds Momentum | Phil Carr",
  "/blog/local-seo-and-ai-optimising-for-voice-and-community": "Local SEO and AI: Voice and Community | Phil Carr",
  "/blog/protecting-against-spam-and-algorithmic-penalties": "Avoiding SEO Spam and Search Penalties | Phil Carr",
  "/blog/quality-content-and-e-e-a-t-raising-the-bar-for-trust": "Quality Content and E-E-A-T: Building Trust | Phil Carr",
  "/blog/the-rise-of-brand-seo-building-authority-for-2025": "Brand SEO: Building Authority for 2025 | Phil Carr",
  "/blog/rethinking-seo-for-2025-putting-people-before-keywords": "SEO in 2025: Putting People First | Phil Carr",
  "/blog/why-seo-starts-with-your-website-and-always-will": "Why SEO Starts With Your Website | Phil Carr",
  "/blog/why-consistency-matters-more-than-quick-wins-in-seo": "Why Consistency Matters in SEO | Phil Carr",
  "/blog/seo-for-contractors-winning-higher-value-project-enquiries": "SEO for Contractors: Better Enquiries | Phil Carr",
  "/blog/seo-for-electricians-emergency-versus-planned-search-intent": "SEO for Electricians: Search Intent | Phil Carr",
  "/blog/seo-for-plumbers-emergency-boiler-and-bathroom-search-intent": "SEO for Plumbers: Search Intent | Phil Carr",
  "/blog/seo-in-2026-how-local-yorkshire-businesses-can-win-more-customers-from-google": "SEO in 2026 for Yorkshire Businesses | Phil Carr",
  "/blog/seo-in-an-ai-driven-search-world-what-small-businesses-need-to-focus-on": "SEO in AI Search: Focus Areas | Phil Carr",
  "/blog/seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026": "Small Business SEO Strategy 2026 | Phil Carr",
  "/blog/tackling-zero-click-searches-turning-visibility-into-value": "Zero-Click Search: Visibility to Value | Phil Carr",
  "/blog/user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond": "Core Web Vitals 2.0 and UX | Phil Carr",
  "/blog/why-seo-is-still-one-of-the-best-investments-for-growing-businesses": "SEO as a Growth Investment | Phil Carr",
  "/blog/why-seo-should-be-driving-your-business-growth-not-just-rankings": "SEO for Business Growth, Not Rankings | Phil Carr"
};

export function pageMetaTitle(path: string, fallback: string): string {
  return SEARCH_TITLE_OVERRIDES[path] ?? fallback;
}

export function cleanBlogTitle(title: string): string {
  return title.replace(BLOG_BRAND_SUFFIX, "").trim();
}

export function blogMetaTitle(title: string, slug?: string): string {
  const fallback = `${cleanBlogTitle(title)} — Phil Carr`;
  return slug ? pageMetaTitle(`/blog/${slug}`, fallback) : fallback;
}

export function metaDescription(description: string, maxLength = 150): string {
  const clean = description
    .replace(/<[^>]*>/g, " ")
    .replace(/[*_`#]/g, "")
    .replace(/\s+/g, " ")
    .trim();

  if (clean.length <= maxLength) return clean;

  const shortened = clean.slice(0, maxLength - 1);
  const lastSpace = shortened.lastIndexOf(" ");
  const cutAt = lastSpace > maxLength * 0.7 ? lastSpace : shortened.length;
  return `${shortened.slice(0, cutAt).trimEnd()}…`;
}

export type BreadcrumbItem = { name: string; url: string };

export function breadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function breadcrumbScript(items: BreadcrumbItem[]) {
  return {
    type: "application/ld+json",
    children: JSON.stringify(breadcrumbSchema(items)),
  };
}
